import React, { useEffect, useState } from 'react'
import { CustomDialog } from '../../../components/StyledComponents'
import { DialogActions, DialogContent, DialogTitle, FormControl } from '@mui/material'
import DefaultTooltip from '../../../components/DefaultTooltip'
import QuestionIcon16pxSvg from '../../../assets/images/icons/QuestionIcon16pxSvg'
import { ControlpanelPrimaryButton, ControlpanelSecondaryButton, GrayIconButton } from '../../../components/StyledButton'
import CloseIcon from '@mui/icons-material/Close';
import CustomInput from '../../../components/CustomInput'
import { useTranslation } from 'react-i18next'
import CustomSelect from '../../../components/CustomSelect'
import SaveIcon14pxSvg from '../../../assets/images/icons/SaveIcon14pxSvg'

const EditApiAccessDialog = (props) => {
    const { t } = useTranslation()
    const { info } = props

    const handleCloseDialog = () => {
        props.handleClose()
    }

    const initialFormData = {
        userName: info.userName,
        password: "",
        description: info.description,
        apiAccess: "auditor",
    };

    const [formData, setFormData] = useState(initialFormData)

    useEffect(() => {
        setFormData(initialFormData)
    }, [props.open])

    const [validationMessages, setValidationMessages] = useState({
        userName: "",
        password: "",
        description: ""
    });

    const handleInputChange = (e) => {
        const { name, value } = e.target;
        setFormData((prevData) => ({
            ...prevData,
            [name]: value,
        }));
    }

    const apiAccessData = [
        { value: "auditor", label: "Read only (Auditor)" },
        { value: "admin", label: "Read-write (Admin)" }
    ]

    return (
        <CustomDialog
            maxWidth={"xl"}
            open={props.open}
            onClose={handleCloseDialog}
            keepMounted
        >
            <DialogTitle>
                <div className='flex justify-between'>
                    <div className='flex items-center gap-4'>
                        <p className='text-xl font-semibold '>Edit API Access - {info.userName}</p>
                        <DefaultTooltip
                            readMore={true}
                            title="Edit API Access"
                            content={
                                <div className='flex flex-col gap-3'>
                                    <p>This view allows the editing of the API access details.</p>
                                </div>
                            }>
                            <QuestionIcon16pxSvg className="fill-[#BDBDBD]" />
                        </DefaultTooltip>
                    </div>
                    <GrayIconButton onClick={handleCloseDialog}>
                        <CloseIcon />
                    </GrayIconButton>
                </div>
            </DialogTitle>
            <DialogContent>
                <div className='grid grid-cols-2 gap-x-10'>
                    <div className='col-span-1'>
                        <CustomInput
                            required={true}
                            title={t('common.user-name')}
                            inputType="text"
                            name="userName"
                            // isError={isEmailError}
                            // isSuccess={isEmailSuccess}
                            placeholder="User name"
                            message={validationMessages.userName}
                            handleInputChange={handleInputChange}
                            value={formData.userName}
                            // readOnly={true}
                        />
                    </div>
                    <div className='col-span-1'>
                        <CustomInput
                            required={true}
                            title={t('common.password')}
                            inputType="password"
                            name="password"

                            // isError={isEmailError}
                            // isSuccess={isEmailSuccess}
                            placeholder="Password"
                            message={validationMessages.password}
                            handleInputChange={handleInputChange}
                            value={formData.password} />
                    </div>
                    <div className='col-span-1'>
                        <CustomInput
                            required={true}
                            title={t('common.description')}
                            inputType="text"
                            name="description"
                            // isError={isEmailError}
                            // isSuccess={isEmailSuccess}
                            placeholder="User group code"
                            message={validationMessages.description}
                            handleInputChange={handleInputChange}
                            value={formData.description}
                        />

                    </div>
                    <div className='col-span-1'>
                        <div className='pt-4'>
                            <label className="block text-sm">
                                Biometric authentication
                                <span className='text-[#DC2626] ml-1'>*</span>
                            </label>
                            <div className='mt-2 mb-3'>
                                <FormControl className='w-full'>
                                    <CustomSelect
                                        name="apiAccess"
                                        value={formData.apiAccess}
                                        onChange={handleInputChange}
                                        options={apiAccessData}
                                        defaultValue="auditor"
                                        readOnly={true}
                                    />
                                </FormControl>
                            </div>
                        </div>
                    </div>
                </div>
            </DialogContent>
            <DialogActions>
                <div className='flex gap-2 px-4 py-4'>
                    <ControlpanelSecondaryButton onClick={props.handleClose}>
                        <CloseIcon />
                        <p>{t('button.close')}</p>
                    </ControlpanelSecondaryButton>
                    <ControlpanelPrimaryButton onClick={props.handleClose}>
                        <SaveIcon14pxSvg />
                        <p>Save</p>
                    </ControlpanelPrimaryButton>
                </div>
            </DialogActions>
        </CustomDialog>
    )
}

export default EditApiAccessDialog